
import { DrawOutlined } from '@mui/icons-material';
import { ActionItemKeys, ActionItemStatus } from '@uplift/api';
import { useActionItem } from '@uplift/hooks';
import { LinkDashboardActionItem, LoadableTypography } from '@uplift/ui-v2';

import { useSharedStyles } from '../../styles';
import { ROUTING_CONFIG } from '@uplift/constants';
import React from 'react';
import { Typography } from '@mui/material';
import { StatesLabel } from '../../../../components/StatesLabel';

export type SignCollaborativeAgreementsProps = {
  status: ActionItemStatus;
};

export const SignCollaborativeAgreements: React.VFC<SignCollaborativeAgreementsProps> = () => {
  const unsignedAgreementsActionItem = useActionItem(ActionItemKeys.PROVIDER_UNSIGNED_COLLABORATIVE_AGREEMENTS);
  const { classes: sharedClasses } = useSharedStyles();

  return (
    <LinkDashboardActionItem
      title={<>Sign <b>{unsignedAgreementsActionItem.stateIds.length}</b> Collaborative Practice Agreements</>}
      body={(
        <React.Suspense
          fallback={(
            <LoadableTypography variant="body2" width="300px" />
          )}
        >
          <Typography variant="body2">
            <StatesLabel stateIds={unsignedAgreementsActionItem.stateIds} />
          </Typography>
        </React.Suspense>
      )}
      bodyClassName={sharedClasses.actionItemSubtitle}
      color="warning"
      icon={<DrawOutlined />}
      link={ROUTING_CONFIG.documentsCenter}
      actionText="Sign"
    />
  );
};
